// Ukrainian noun-count agreement (1 заклад / 2-4 заклади / 5+ закладів).
// Only applies to exact counts - an open-ended "N+" quantity (e.g. "16+
// закладів") conventionally always takes the genitive-plural form regardless
// of N, so callers using that phrasing don't need this helper.
export function pluralizeUk (count, [one, few, many]) {
  const mod10 = count % 10
  const mod100 = count % 100
  if (mod10 === 1 && mod100 !== 11) {
    return one
  }
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) {
    return few
  }
  return many
}
